<template>
  <div class="editor" v-if="editor">
    <b-loading v-model="isLoading" :active="isLoading" :is-full-page="false" />
    <div class="editor__header" v-if="editor">
      <b-navbar style="width: 100%; overflow: auto">
        <template #start>
          <b-navbar-item>
            <b-switch v-model="isAnnotation"> Annotation </b-switch>
          </b-navbar-item>
        </template>

        <template #end>
          <b-navbar-item>
            <b-button
              title="Increase font size"
              icon-left="plus"
              @click="setFontSize(0.1)"
            >
            </b-button>
            <b-button
              title="Decrease font size"
              icon-left="minus"
              @click="setFontSize(-0.1)"
            >
            </b-button>
          </b-navbar-item>
          <b-navbar-item>
            <b-button
              title="Switch view"
              :icon-left="layoutIcon()"
              @click="setEditLayout"
            >
            </b-button>

            <b-button
              title="Undo"
              icon-left="undo"
              @click="editor.chain().focus().undo().run()"
            >
            </b-button>
            <b-button
              title="Redo"
              icon-left="redo"
              @click="editor.chain().focus().redo().run()"
            >
            </b-button>
          </b-navbar-item>
          <b-navbar-item>
            <b-field>
              <b-button @click="saveContent" icon-left="save" type="is-success">
                Save
              </b-button>
            </b-field>
          </b-navbar-item>
          <!-- <b-navbar-item>
            <b-button
              title="Advanced"
              type="is-light"
              icon-left="toolbox"
              @click="openAdvancedModal"
            />
          </b-navbar-item> -->
        </template>
      </b-navbar>
    </div>
    <div class="tile editor__content">
      <div v-if="isAnnotation" class="tile is-parent is-vertical is-3">
        <div v-if="selectedTag" class="tile is-child box">
          <div>
            <div
              class="tile is-vertical"
              style="width: 100%"
              v-for="(tempTag, index) in selectedTag.marks"
              :key="index"
            >
              <div class="tile is-child" v-if="tempTag.attrs.tag">
                <b-tag
                  :style="`outline-color: ${tempTag.attrs.color} !important; outline: 2px solid; color : ${tempTag.attrs.color} !important;margin-top: auto;margin-bottom: auto;`"
                  icon-left="tag"
                >
                  {{ tempTag.attrs.tag.name }}
                </b-tag>
              </div>
              <div
                class="tile is-child"
                v-for="(attribute, i) in findTagAttributes(tempTag)"
                :key="i"
              >
                <b-field
                  v-if="tempTag.attrs.tag"
                  :label="attribute"
                  label-position="on-border"
                >
                  <b-input
                    @input="
                      changeContinued(
                        tempTag,
                        tempTag.attrs.tag.attributes[attribute],
                        attribute
                      )
                    "
                    v-model="tempTag.attrs.tag.attributes[attribute]"
                  ></b-input>
                </b-field>
              </div>
              <div class="tile is-child" v-if="tempTag.attrs.tag">
                <b-button
                  type="is-danger"
                  icon-left="trash"
                  @click="deleteTag()"
                >
                  Delete
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-child box">
          <div
            class="transkribusEditor-bubble-menu"
            style="text-align: center"
            v-if="editor && isAnnotation && tagDefs"
          >
            <b-button
              title="Bold"
              type="is-primary"
              icon-left="bold"
              @click="editor.chain().focus().toggleBold().run()"
              :class="{ 'is-active': editor.isActive('bold') }"
            >
            </b-button>
            <b-button
              title="Strike"
              type="is-primary"
              icon-left="strikethrough"
              @click="editor.chain().focus().toggleStrike().run()"
              :class="{ 'is-active': editor.isActive('strike') }"
            >
            </b-button>
            <b-button
              title="Underline"
              type="is-primary"
              icon-left="underline"
              @click="editor.chain().focus().toggleUnderline().run()"
              :class="{ 'is-active': editor.isActive('underline') }"
            >
            </b-button>
            <b-button
              title="Subscript"
              type="is-primary"
              icon-left="subscript"
              @click="editor.chain().focus().toggleSub().run()"
              :class="{ 'is-active': editor.isActive('subscript') }"
            >
            </b-button>
            <b-button
              title="Superscript"
              type="is-primary"
              icon-left="superscript"
              @click="editor.chain().focus().toggleSuper().run()"
              :class="{ 'is-active': editor.isActive('superscript') }"
            >
            </b-button>
            <br />
            <b-button
              v-for="(tag, index) in tagDefs.definitions.annotations"
              :key="index"
              icon-left="tag"
              :style="'background-color:' + tag.color"
              @click="setAttributes(tag)"
              :class="{
                'is-active': editor.isActive(tag.name, {
                  color: tag.color,
                }),
              }"
            >
              {{ tag.label }}
            </b-button>
          </div>
        </div>
      </div>
      <div class="tile is-parent box">
        <editor-content
          class="editor__content"
          v-bind:style="{ fontSize: fontSize + 'rem' }"
          :editor="editor"
        />
      </div>
    </div>
  </div>
</template>

<script>
//  http://localhost:5000/collection/62267/doc/425931/detail/1?view=edit
// http://localhost:5000/collection/100402/doc/512221/detail/2
//  http://localhost:5000/collection/100402/doc/642576/detail/3

//TODO adding continued tag and set attributes to continued tags
import {
  generateHTML,
  Editor,
  EditorContent,
  NodeViewWrapper,
  NodeViewContent,
  BubbleMenu,
} from "@tiptap/vue-2";
import { defaultExtensions } from "@tiptap/starter-kit";
import TextAlign from "@tiptap/extension-text-align";
import StarterKit from "@tiptap/starter-kit";
import Focus from "@tiptap/extension-focus";
import Text from "@tiptap/extension-text";
import Region from "../Editor/RegionExtension.js";
import Line from "../Editor/LineExtension.js";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import Underline from "@tiptap/extension-underline";
import { tagExtensions } from "../Editor/TagExtension.js";

import { Subscript } from "../Editor/SubscriptExtension.js";
import { Superscript } from "../Editor/SuperscriptExtension.js";

import { NodeSelection } from "prosemirror-state";
import { Plugin, PluginKey } from "prosemirror-state";

import { mapState } from "vuex";

import { fetchTagDef, setPageContentXML } from "../../utils/api.js";

import { parseToXML, parseEditorOutput } from "../../utils/xml.js";

var groupBy = require("json-groupby");

export default {
  filters: {
    text(item) {
      return item.elements && item.elements[0] ? item.elements[0].text : "";
    },
    clean(s) {
      if (typeof s !== "string") return "";
      return s.trim().replace(/¬$/, "\u2010");
    },
  },
  watch: {
    selected: {
      handler: function (newValue, oldValue) {
        if (newValue === null || newValue === oldValue) return;
        if (newValue.origin === "image") {
          var lineId = newValue.target;
          var content = this.editor.state.doc.content.content;
          this.editor.chain().focus();
          var nodes = this.editor.view.docView.node;

          nodes.descendants((node, pos) => {
            if (node.attrs.line) {
              if (node.attrs.line.attributes.id === lineId) {
                var tr = this.editor.state.tr;
                const transaction = tr.setSelection(
                  NodeSelection.create(tr.doc, pos)
                );
                this.editor.view.dispatch(transaction);
                const el = document.getElementById(lineId);
                el.scrollIntoView({ behavior: "smooth" });
              }
            }
          });
        }
      },
      deep: true,
    },
    tagDefs: {
      handler: function (newValue, oldValue) {
        this.setup();
      },
      deep: true,
    },
    contentData: {
      handler: function (newValue, oldValue) {
        this.setEditorContentJSON();
      },
      deep: true,
    },
  },
  components: {
    TextAlign,
    EditorContent,
    BubbleMenu,
  },
  props: {
    // xmlJson: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    return {
      editorContentJson: {},
      editor: null,
      isAnnotation: false,
      selectedTag: null,
      status: "IN_PROGRESS",
      isLoading: false,
      annotationCounter: 0,
      lastTag: {},
      fontSize: 1,
    };
  },
  computed: {
    ...mapState("content", [
      "data",
      "selected",
      "highlighted",
      "isReady",
      "xmlModel",
      "wasSaved",
      "wasEdited",
      "editLayoutHorizontal",
      "xmlJson",
    ]),
    ...mapState("detail", ["tagMode", "tsKey"]),
    ...mapState("browse", ["tagDefs"]),
    hasContent() {
      return this.content.elements.length !== 0;
    },
    contentData() {
      console.log("xmlJson in content data", this.xmlJson);
      if (!this.xmlJson || !this.xmlJson.elements) return { elements: [] };
      else {
        for (var element in this.xmlJson.elements) {
          var temp = this.xmlJson.elements[element];
          for (var line in temp.elements) {
            var linetemp = temp.elements[line];

            if (linetemp.type == "TextLine") {
              linetemp.hasTag = this.hasTag(linetemp.attributes.custom);
              linetemp.tags = this.getTags(linetemp.attributes.custom);
            } else if (linetemp.type == "TableCell" && linetemp.elements[0]) {
              linetemp.hasTag = this.hasTag(
                linetemp.elements[0].attributes.custom
              );
              linetemp.tags = this.getTags(
                linetemp.elements[0].attributes.custom
              );
            }
          }
        }
        return this.xmlJson;
      }
    },
  },
  async mounted() {
    this.setup();
  },
  methods: {
    async setup() {
      var tagArray = await tagExtensions(this.tagDefs.definitions.annotations);
      var that = this;
      this.editor = await new Editor({
        content: "",
        extensions: [
          Text,
          Region,
          Line,
          StarterKit,
          ...tagArray,
          Focus.configure({
            className: "is-selected",
            nested: true,
          }),
          Underline,
          Table,
          TableRow,
          TableHeader,
          TableCell,
          Subscript,
          Superscript,
        ],
        onSelectionUpdate({ editor }) {
          var selectedLine = editor.getAttributes("line");
          var head = editor.view.state.selection.$head.pos;
          var anchor = editor.view.state.selection.$anchor.pos;
          var node = editor.view.state.doc.nodeAt(head);
          if (node && anchor == head) {
            var marks = node.marks;
            if (marks.length > 0) {
              that.selectedTag = node;
            } else {
              that.selectedTag = null;
            }
          } else {
            that.selectedTag = null;
          }
        },
        onUpdate({ editor }) {
          that.$store.dispatch("content/update", { wasEdited: true });
        },
      });
      this.setEditorContentJSON();
    },
    select(id) {
      this.$store.dispatch("content/select", {
        target: id,
        origin: "content",
      });
    },
    setEditLayout() {
      this.$store.dispatch("content/update", {
        editLayoutHorizontal: !this.editLayoutHorizontal,
      });
    },
    layoutIcon() {
      if (this.editLayoutHorizontal) {
        return "columns";
      }
      return "bars";
    },
    changeContinued(tag, value, attribute) {
      if (tag.attrs.tag.attributes.continued) {
        var continuedTags = this.findMarkByUid(0, 1000, tag.attrs.annotationId);
        for (var index in continuedTags) {
          var tempTag = continuedTags[index];
          tempTag.attrs.tag.attributes[attribute] = value;
        }
      }
    },
    setFontSize(value) {
      this.fontSize += value;
    },
    findMarkByUid(from, to, uid) {
      const { doc } = this.editor.state;
      let found = [];
      doc.nodesBetween(from, to, (node) => {
        found.push(
          node.marks.find((mark) => mark.attrs["annotationId"] === uid)
        );
      });
      return found.filter(Boolean);
    },
    findTagAttributes(tag) {
      var found = {};
      found = this.tagDefs.definitions.annotations.find(
        (element) => element.name === tag.type.name
      );
      if (found) {
        return found.attributes;
      } else {
        return found;
      }
    },

    async saveContent() {
      const json = this.editor.getJSON();
      var js = JSON.parse(JSON.stringify(json));
      let fullText =  this.editor.getText()
      var modelCopy = JSON.parse(JSON.stringify(this.xmlModel));

      var parsedResult = parseEditorOutput(js, modelCopy);
      var xmlResult = parseToXML(parsedResult);
      var output = { xml: xmlResult, xmlJson: parsedResult, text: fullText };
      this.$root.$emit("save", output);
    },
    deleteTag() {
      this.selectedTag.marks = [];
      this.selectedTag = null;
      this.editor.chain().focus().run();
    },
    setAttributes(tag) {
      var attributes = {};
      var contentObj = this.editor.state.selection.content();

      if (
        contentObj.content.content[0] &&
        contentObj.content.content[0].content.content.length > 1
      ) {
        attributes = { continued: true };
      }
      var tagObj;
      var tagName;
      var tagColor;
      if (tag.name) {
        tagObj = { name: tag.name, attributes: attributes };
        tagName = tag.name;
        tagColor = tag.color;
      } else {
        tagName = tag.attrs.tag.name;
        tagColor = tag.attrs.color;
        tagObj = { name: tagName, attributes: attributes };
      }
      this.editor
        .chain()
        .focus()
        .toggleTag({ color: tagColor, tag: tagObj, name: tagName })
        .run();

      var selectedLine = this.editor.getAttributes("line");
      var anchor = this.editor.state.selection.$anchor.pos;
      var node = this.editor.state.doc.nodeAt(anchor);
      if (node && node.marks) {
        var marks = node.marks;
        if (marks.length > 0) {
          this.selectedTag = node;
        } else {
          this.selectedTag = null;
        }
      } else {
        this.selectedTag = null;
      }
    },
    openToast(message, type) {
      this.$buefy.toast.open({
        duration: 4000,
        message: message,
        position: "is-top",
        type: type,
      });
    },
    async loadTagDefs() {
      let data;
      try {
        data = await fetchTagDef({
          collId: this.$route.params.collectionid,
        });
      } catch (err) {
        console.log(err);
      }
      this.$store.dispatch("browse/setTagDefs", { tagDefs: data });
    },
    groupByRow(table) {
      var result = groupBy(table, ["attributes.row"]);
      return result;
    },
    getTagDef(tag) {
      if (tag) {
        var found = this.tagDefs.definitions.annotations.find(
          (x) => x.name === tag.name
        );
      }

      return found;
    },
    beforeDestroy() {
      if (this.editor) {
        this.editor.destroy();
      }
    },
    setEditorContentJSON() {
      let editorContent = {
        type: "doc",
        content: [],
      };

      if (!this.contentData || !this.contentData.elements)
        return { elements: [] };
      else {
        for (var element in this.contentData.elements) {
          var temp = this.contentData.elements[element];
          var content = [];
          if (temp.type == "TextRegion") {
            for (var line in temp.elements) {
              var linetemp = temp.elements[line];
              if (linetemp.type == "TextLine") {
                if (linetemp.elements[0]) {
                  var id = linetemp.attributes.id;
                  var text = "";
                  if (
                    linetemp.elements[0].elements[0][0] &&
                    linetemp.elements[0].elements[0][0][0]
                  ) {
                    text = linetemp.elements[0].elements[0][0][0].text;
                  }
                  if (linetemp.hasTag) {
                    var tagContent = this.setTagContent(linetemp, text, false);
                    content.push({
                      type: "line",
                      attrs: {
                        line: linetemp,
                      },
                      content: tagContent,
                    });
                  } else {
                    if (text) {
                      content.push({
                        type: "line",
                        attrs: {
                          line: linetemp,
                        },
                        content: [
                          {
                            type: "text",
                            text: text,
                          },
                        ],
                      });
                    } else {
                      content.push({
                        type: "line",
                        attrs: {
                          line: linetemp,
                        },
                      });
                    }
                  }
                }
              }
            }
            editorContent.content.push({
              type: "region",
              attrs: {
                lines: temp,
              },
              content: content,
            });
          } else if (temp.type == "TableRegion") {
            var groupedRows = this.groupByRow(temp.elements);
            var rowContent = [];
            for (var row in groupedRows) {
              var cellContent = [];
              var rowtemp = groupedRows[row];
              for (var cell in rowtemp) {
                var celltemp = rowtemp[cell];
                var text = "";
                var lineObjects = [];
                for (line in celltemp.elements) {
                  var linetemp = celltemp.elements[line];
                  if (linetemp && linetemp.elements[0][0][0].elements[0]) {
                    text = linetemp.elements[0][0][0].elements[0].text;
                  }
                  var lineContent = [];
                  if (celltemp.hasTag) {
                    lineContent = this.setTagContent(celltemp, text, true);
                  } else {
                    lineContent.push({
                      type: "text",
                      text: text,
                    });
                  }
                  let lineObj;
                  if (text) {
                    lineObj = {
                      type: "line",
                      attrs: {
                        line: linetemp,
                      },
                      content: lineContent,
                    };
                  } else {
                    lineObj = {
                      type: "line",
                      attrs: {
                        line: linetemp,
                      },
                    };
                  }
                  lineObjects.push(lineObj);
                }
                cellContent.push({
                  type: "tableCell",
                  content: lineObjects,
                });
              }
              rowContent.push({
                type: "tableRow",
                content: cellContent,
              });
            }
            var regionObj = {
              type: "region",
              content: rowContent,
            };

            editorContent.content.push({
              type: "table",
              content: [regionObj],
            });
          }
        }
        this.editorContentJson = editorContent;
        if(this.editor){
          this.editor.commands.setContent(editorContent);
        }
      }
    },
    getTags(attributes) {
      var tags = [];
      for (var i = 0; i < attributes.length; i++) {
        if (
          "offset" in attributes[i].attributes &&
          "length" in attributes[i].attributes
        ) {
          tags.push(attributes[i]);
        }
      }
      return tags;
    },
    hasTag(attributes) {
      for (var i = 0; i < attributes.length; i++) {
        if (
          "offset" in attributes[i].attributes &&
          "length" in attributes[i].attributes
        ) {
          return true;
        }
      }
      return false;
    },
    setTagContent(linetemp, text, table) {
      var tagContent = [];
      var arrText = this.stringOffset(text, linetemp.tags);
      for (var split in arrText) {
        var marks = [];
        var text = " ";
        if (!arrText[split] == "") {
          text = arrText[split];
        }
        var offset = 0;
        for (var i = 0; i < split; i++) {
          offset += arrText[i].length;
        }
        var tags = this.findTags(linetemp, text, table, offset);
        if (tags.length > 0) {
          for (var tagTemp in tags) {
            var tag = tags[tagTemp];
            if (tag.name == "textStyle") {
              var textStyles = this.setTextStyles(tag);
              for (var index in textStyles) {
                var textStyle = textStyles[index];
                marks.push(textStyle);
              }
            }
            var tagDef = this.getTagDef(tag);
            var color = "#ffff";
            var name = "mark";
            if (tagDef) {
              color = tagDef.color;
              name = tagDef.name;
              if (
                !tag.attributes.continued ||
                this.lastTag.name !== name ||
                this.lastTag.continued !== tag.attributes.continued
              ) {
                this.annotationCounter++;
              }
              var tagMark = {
                type: name,
                attrs: {
                  color: color,
                  tag: tag,
                  annotationId: this.annotationCounter,
                },
              };
              this.lastTag = {
                name: tag.name,
                lineId: linetemp.attributes.id,
                tag: tag,
                continued: tag.attributes.continued,
              };
              marks.push(tagMark);
            }
          }
          var obj = {
            type: "text",
            marks: marks,
            text: text,
          };
          tagContent.push(obj);
        } else {
          var obj = {
            type: "text",
            marks: marks,
            text: text,
          };
          tagContent.push(obj);
        }
      }
      return tagContent;
    },
    setTextStyles(tag) {
      var name = [];
      if (tag.attributes.strikethrough) {
        name.push("strike");
      }
      if (tag.attributes.subscript) {
        name.push("subscript");
      }
      if (tag.attributes.superscript) {
        name.push("superscript");
      }
      if (tag.attributes.underlined) {
        name.push("underline");
      }
      if (tag.attributes.bold) {
        name.push("bold");
      }
      var textStyleArr = [];
      for (var i = 0; i < name.length; i++) {
        textStyleArr.push({
          type: name[i],
        });
      }
      return textStyleArr;
    },
    stringOffset(str, tags) {
      if (!tags.length) return [];

      const results = [],
        indexes = [];

      tags.forEach((options) => {
        indexes.push(
          options.attributes.offset,
          options.attributes.offset + options.attributes.length
        );
      });

      indexes.sort((i1, i2) => i1 - i2);

      if (indexes.indexOf(0) < 0) indexes.unshift(0);

      if (indexes[indexes.length - 1] < str.length) indexes.push(str.length);

      for (let i = 0, len = indexes.length; i < len - 1; i++) {
        results.push(str.substring(indexes[i], indexes[i + 1]));
      }

      return results;
    },
    findTags(element, text, table, offset) {
      var lineText;
      if (table) {
        lineText = element.elements[0].elements[0][0][0].elements[0].text;
      } else {
        lineText = element.elements[0].elements[0][0][0].text;
      }
      if (text == " ") {
        return [];
      }
      var index = lineText.indexOf(text);
      return element.tags.filter((x) => {
        var tagtext = lineText.substr(x.attributes.offset, x.attributes.length);
        if (
          tagtext.includes(text) &&
          offset >= x.attributes.offset &&
          offset <= x.attributes.offset + x.attributes.length
        ) {
          return x;
        }
      });
    },
    textStyleClass(label) {
      var classString = "";
      if (label.includes("superscript = true")) {
        classString += "is-superscript";
      }
      if (label.includes("subscript = true")) {
        classString += "is-subscript";
      }
      if (label.includes("italic = true")) {
        classString += "is-italic";
      }
      if (label.includes("underlined = true")) {
        classString += "is-underlined";
      }
      if (label.includes("strikethrough = true")) {
        classString += "is-strikethrough";
      }
      if (label.includes("bold = true")) {
        classString += "is-bold";
      }

      return classString;
    },
    highlight(id) {
      this.$store.dispatch("content/highlight", {
        target: id,
        origin: "content",
      });
    },
    scrollIntoView(id) {
      if (!this.$refs[id]) return;
      const [element] = this.$refs[id];
      if (element)
        element.scrollIntoView({
          block: "center",
          inline: "center",
          behavior: "smooth",
        });
    },
  },
};
</script>
